var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { CART_QUANTITY_CHANGED, INITIALIZE_FROM_SIGN, UPLOADED_IMAGES, } from '../Rutab/RutabConstants';
import { FabricImage, loadSVGFromString, Textbox, util } from 'fabric';
import { overrideRotationControl, setVisibilityControlsForObject, } from './CanvasService';
import { ChangeForm } from './CanvasFormService';
import { handleSizeChange, updateMeasurementPositions, } from './DecalEditorCanvasSizing';
export const BuildCanvasFromExistingSign = (sign, canvas, canvasRef, dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    canvas.set({ backgroundColor: sign.canvasBackgroundColor });
    handleSizeChange(sign.canvasSize, canvas, sign.holePlacement, false);
    updateMeasurementPositions(sign.canvasSize.height, sign.canvasSize.width, canvasRef);
    if (sign.canvasForms.formKey !== 'none-form') {
        ChangeForm(canvas, canvasRef, sign.canvasForms, false);
    }
    dispatch({
        type: INITIALIZE_FROM_SIGN,
        payload: {
            canvasSize: sign.canvasSize,
            canvasType: sign.canvasType,
            canvasForms: sign.canvasForms,
            objectCount: sign.objects.length,
            holePlacement: sign.holePlacement,
        },
    });
    if (sign.quantity > 1) {
        dispatch({
            type: CART_QUANTITY_CHANGED,
            payload: {
                cartQuantity: sign.quantity,
            },
        });
    }
    for (const object of sign.objects) {
        if (object.type === 'text') {
            buildTextbox(object, canvas);
        }
        if (object.type === 'path') {
            yield buildIcon(object, canvas);
        }
        if (object.type === 'image') {
            buildImage(canvas, object);
        }
    }
    if (sign.objects.filter((o) => o.type === 'image').length > 0) {
        const uniqueImages = Array.from(sign.objects
            .filter(obj => { var _a; return obj.type === 'image' && ((_a = obj.imageObject) === null || _a === void 0 ? void 0 : _a.systemId); })
            .reduce((map, obj) => {
            map.set(obj.imageObject.systemId, obj.imageObject);
            return map;
        }, new Map())
            .values());
        dispatch({
            type: UPLOADED_IMAGES,
            payload: { uploadedImages: uniqueImages },
        });
    }
    canvas.renderAll();
});
const buildTextbox = (object, canvas) => {
    const textbox = new Textbox(object.textObject.text, {
        left: object.left,
        top: object.top,
        width: object.width,
        height: object.height,
        scaleX: object.scaleX,
        scaleY: object.scaleY,
        angle: object.angle,
        text: object.textObject.text,
        fontSize: object.textObject.fontSize,
        fontFamily: object.textObject.fontFamily,
        fontWeight: object.textObject.fontWeight,
        fontStyle: object.textObject.fontStyle,
        fill: object.textObject.fill,
        stroke: object.textObject.stroke,
        strokeWidth: object.textObject.strokeWidth,
        textAlign: object.textObject.textAlign,
        underline: object.textObject.textDecoration == 'true',
        borderColor: 'none',
        cornerColor: '#112d61',
        cornerSize: 12,
        cornerStyle: 'circle',
        transparentCorners: false,
        padding: 0,
        objectCaching: false,
        noScaleCache: false,
        centeredScaling: true,
        breakWords: true,
        wordWrap: true,
        lineHeight: 1,
        id: 'text',
    });
    setVisibilityControlsForObject(textbox);
    overrideRotationControl(textbox);
    canvas.add(textbox);
};
const buildIcon = (object, canvas) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const { objects, options } = yield loadSVGFromString(object.iconObject.svg);
        const obj = util.groupSVGElements(objects, options);
        obj.set({
            fill: object.iconObject.fill,
            objectCaching: false,
            noScaleCache: false,
            borderColor: 'none',
            cornerColor: '#112d61',
            cornerSize: 12,
            cornerStyle: 'circle',
            transparentCorners: false,
            centeredScaling: true,
            id: 'icon',
        });
        setVisibilityControlsForObject(obj);
        overrideRotationControl(obj);
        canvas.add(obj);
    }
    catch (error) {
        console.error('Error loading SVG to canvas:', error);
    }
});
export const buildImage = (canvas, object) => __awaiter(void 0, void 0, void 0, function* () {
    if (!canvas)
        return;
    yield loadImageToCanvas(canvas, object.imageObject.imageSrc, object);
});
const loadImageToCanvas = (canvas, imageUrl, object) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    if (!canvas)
        return;
    try {
        const image = yield FabricImage.fromURL(imageUrl);
        image.set({
            left: object.left,
            top: object.top,
            angle: object.angle,
            objectCaching: false,
            scaleX: object.scaleX,
            scaleY: object.scaleY,
            noScaleCache: false,
            borderColor: 'none',
            cornerColor: '#112d61',
            cornerSize: 12,
            cornerStyle: 'circle',
            transparentCorners: false,
            centeredScaling: true,
            systemId: (_a = object.imageObject) === null || _a === void 0 ? void 0 : _a.systemId,
        });
        image.set({
            'cart-image': object.imageObject,
        });
        setVisibilityControlsForObject(image);
        overrideRotationControl(image);
        canvas.add(image);
    }
    catch (error) {
        console.error('Error loading image to canvas:', error);
    }
});
